import css from "styled-jsx/css";

export const componentStyles = css.global`
  .live-board-tab-wrapper {
    .description-wrapper {
      text-align: left;
    }
  }
`;
